// extracted by mini-css-extract-plugin
module.exports = {"datewrap":"dates_datewrap__2sTot","date":"dates_date__M-hQB","weekday":"dates_weekday__37TEz","range":"dates_range__iUXjg"};